import { withTranslation } from "react-i18next";
import TourTypes from './TourTypes';

export default withTranslation()(TourTypes);